import React from "react";
import Image from "next/image";
import Apple from "@/app/assets/icons/apple";
import { IMAGE_TYPE } from "@/app/enums/ui";
import GooglePlay from "@/app/assets/icons/googleplay";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

interface FdGraphProps {
    toggleDownloadApp: (arg0: string) => void;
    highestReturns: number;
    isLoading: boolean;
}

const FdGraph: React.FC<FdGraphProps> = ({ toggleDownloadApp, highestReturns, isLoading }) => {
    return (
        <div
            id="fd-graph-container"
            className="flex w-full flex-col items-center justify-center bg-neutral-50 px-6 !pb-9 pt-6 md:py-s20"
        >
            <p
                id="fd-graph-title"
                className="text-center text-4xl font-semibold leading-[41.6px] tracking-[-0.48px] md:text-7xl md:leading-[67.2px] md:tracking-[-0.56px]"
            >
                Best time to invest in <br />
                Fixed deposit
            </p>
            <div
                id="fd-graph-wrapper"
                className="my-8 flex w-full flex-col md:mx-auto md:my-16 md:w-[1141px]"
            >
                {isLoading ? (
                    <div className="mr-10 space-y-2 self-end md:mr-[10rem] pb-4">
                        {/* Label Skeleton */}
                        <div className="h-3 text-left w-24 rounded bg-gray-300"></div>

                        {/* Value Skeleton */}
                        <div className="h-8 w-28 rounded bg-gray-300 md:h-16 md:w-32"></div>
                    </div>
                ) : (
                    <p
                        id="fd-graph-returns"
                        className="mr-10 self-end text-[4.61px] font-semibold leading-[17.30px] tracking-[-0.046px] md:mr-[10rem] md:text-base md:leading-[40px] md:tracking-[-0.16px]"
                    >
                        Current Returns
                        <br />
                        <span
                            id="fd-graph-return-value"
                            className="text-[18.54px] font-semibold leading-[17.30px] tracking-[-0.185px] md:text-[64px] md:leading-[40px] md:tracking-[-0.64px]"
                        >
                            {highestReturns?.toFixed(2)}%
                        </span>
                    </p>
                )}
                <Image
                    id="fd-graph-image"
                    src={`${process.env.ICM_IMAGES_URL + IMAGE_TYPE.PNG}/fd-graph.png`}
                    alt={"fd-graph"}
                    className="w-full"
                    width={0}
                    height={0}
                />
            </div>
            <RegularButton
                id="fd-download-button"
                noIcon
                showRightIcon={true}
                rightIcon={
                    <div
                        id="fd-download-icons"
                        className="flex h-12 min-w-16 items-center justify-center gap-s4"
                    >
                        <Apple id="fd-apple-icon" className="h-10 w-10 text-white" />
                        <div
                            id="fd-divider"
                            className="h-full w-[3px] bg-neutralOpacityDark-20"
                        ></div>
                        <GooglePlay id="fd-googleplay-icon" className="h-10 w-10 text-white" />
                    </div>
                }
                size={ButtonSize.Large}
                variant={ButtonVariant.PrimaryDefault}
                label="Download App"
                className="w-full max-w-full md:mb-0 md:max-w-fit"
                onClick={() => toggleDownloadApp("FD_Download_App")}
            />
        </div>
    );
};

export default FdGraph;
